import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
export const RequireAuth = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    isAuthenticated,
    isAuthLoading,
    isDcAuthenticated,
    isPreviewSession,
    refreshDcSession
  } = useAuth();
  const location = useLocation();
  const [isRefreshingDc, setIsRefreshingDc] = React.useState(false);
  if (isAuthLoading) {
    return <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-id="element-210">
        <div className="text-center" data-id="element-211">
          <div className="w-8 h-8 border-2 border-indigo-600/30 border-t-indigo-600 rounded-full animate-spin mx-auto mb-3" data-id="element-212" />
          <p className="text-sm text-slate-500" data-id="element-213">Verifying session...</p>
        </div>
      </div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-214" />;
  }
  if (!isPreviewSession && !isDcAuthenticated) {
    return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-id="element-215">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl p-8 text-center shadow-sm" data-id="element-216">
          <h2 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-217">
            Document Center Session Required
          </h2>
          <p className="text-sm text-slate-600 mb-6" data-id="element-218">
            You are signed in to Lawvo, but a Document Center (Strapi) JWT is
            missing. This is normally created automatically on login — the
            same way lawvo-client and doc-center share <code data-id="element-219">dcState</code>.
          </p>
          <button type="button" disabled={isRefreshingDc} onClick={async () => {
          setIsRefreshingDc(true);
          try {
            await refreshDcSession();
          } finally {
            setIsRefreshingDc(false);
          }
        }} className="w-full py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 disabled:opacity-50" data-id="element-220">
            {isRefreshingDc ? "Connecting..." : "Connect Document Center"}
          </button>
        </div>
      </div>;
  }
  return <>{children}</>;
};